



































import { Component, Vue } from 'vue-property-decorator';
import IconBurger from '@/assets/icons/burger.svg';

@Component({
  name: 'left-bar',
  components: { IconBurger },
})
export default class LeftBar extends Vue {
  drawer = false;
}
